{
  "equipment": "Equipment",
  "rate_day": "Prix/jour",
  "rate_week": "Prix/semaine",
  "qty": "Quantité",
  "rent_period": "Période",
  "add_equipment": "Ajouter equipement",
  "search": "Rechercher"
}
